import { render, staticRenderFns } from "./OIcon.vue?vue&type=template&id=16fa2fa2&"
import script from "./OIcon.vue?vue&type=script&lang=js&"
export * from "./OIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports